import React, { useEffect, useState } from 'react';
import { initAnalytics } from '../utils/analytics';

const ConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const status = localStorage.getItem('consent');
    setVisible(status !== 'granted' && status !== 'denied');
  }, []);

  const accept = () => {
    localStorage.setItem('consent', 'granted');
    initAnalytics();
    setVisible(false);
  };
  const reject = () => {
    localStorage.setItem('consent', 'denied');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 1100,
      background: '#111', color: '#fff', borderTop: '1px solid #222',
    }}>
      <div style={{ maxWidth: 1400, margin: '0 auto', padding: '12px 16px', display: 'flex', gap: 12, alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <div style={{ maxWidth: 800, opacity: 0.95 }}>
          Usamos cookies para medir o uso do site (GA4). Você aceita o uso de cookies para fins estatísticos?
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-light" onClick={accept}>Aceitar</button>
          <button className="btn btn-outline-light" onClick={reject}>Recusar</button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;

